import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ isPointerCursor: boolean }>()(
  (theme, { isPointerCursor }) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      minWidth: theme.spacing(18.75),
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(1.25),
      cursor: isPointerCursor ? 'pointer' : 'default',
    },
  })
);
